const getCellShadingClass = (num, denom, median, stdev, isReverse = false) => {
    if (denom === 0 || (num === 0 && denom === 0)) return null;
    const perc = num / denom;
    let diff = perc - median;
    if (isReverse) diff = median - perc;
    const step = diff / stdev;

    if (step >= 2) return 'cell-shade-positive-2';
    if (step >= 1 && step < 2) return 'cell-shade-positive-1';
    if (step <= -1 && step > -2) return 'cell-shade-negative-1';
    if (step <= -2) return 'cell-shade-negative-2';
    return null;
};

const duplicateNames = (player, players) => {
    let playerName = player?.LastName;
    if (playerName && players?.length >= 2 && players.filter((p) => p.LastName === playerName).length > 1) {
        playerName += `, ${player.UsesName.substring(0, 1)}`;
    }
    return playerName;
};

const valueToTenth = (value) => {
    if (value === null || value === undefined) {
        return value;
    }
    const numberValue = parseFloat(value);
    if (!isNaN(numberValue)) {
        return Math.round(numberValue * 10) / 10;
    }

    return value;
};

export {
    getCellShadingClass,
    duplicateNames,
    valueToTenth,
};
